import { Component, inject, Input, ViewEncapsulation } from '@angular/core';
import { DatePipe, NgIf } from '@angular/common';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { Resources } from '@app/resources';
import { ResourceByIdPipe } from '@shared/pipes/resource-by-id.pipe';
import { PropertyStatusDirective } from '@common/directive/property-status.directive';
import {CardComponent} from '@modules/dashboard/card/card.component';
import urlJoin from 'url-join';
import { environment } from '@environments/environment';
import { NgCanDirective } from '@common/rbac/ng-can.directive';


@Component({
  selector: 'personal-property-info',
  standalone: true,
  imports: [
    NgIf,
    TranslatePipe,
    RouterLink,
    ResourceByIdPipe,
    PropertyStatusDirective,
    DatePipe,
    CardComponent,
    NgCanDirective
  ],
  templateUrl: './personal-property-info.component.html',
  styleUrl: './personal-property-info.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class PersonalPropertyInfoComponent {
  @Input() data: any;
  @Input() index: number;
  @Input() showDetails: boolean = false;
  protected translateService = inject(TranslateService);
  protected readonly Resources = Resources;
  protected readonly urlJoin = urlJoin;

  protected readonly environment = environment;
}
